import { router } from "umi";
import { getRouteByPath } from "@/utils/route";
import { getSessionStorage, removeSessionStorage, setSessionStorage, getLocalStorage } from "@/utils/storage";
import { AccountImpersonate } from "@/services/login";

const Model = {
  namespace: "login",
  state: {
    errorMessage: null,
  },
  effects: {
    *accountImpersonate({ payload }, { call, put, select }) {
      const authData = getLocalStorage("dataAuth");
      const { currentProfile } = yield select(state => state.user);
      let redirectTo = null;

      if (payload.userId) {
        // Impersonating
        setSessionStorage("impersonatorAdminUserEmail", currentProfile.email);

        const { pathname, search } = window.location;
        const route = getRouteByPath(pathname);
        if (!route.cannotRedirectTo) {
          // The pathname should never be included in the excludedPathsToRedirect
          // because it is users details page
          const redirectUrlForUserKey = `redirectUrl-${currentProfile.email}`;
          setSessionStorage(redirectUrlForUserKey, pathname + search);
        }
      } else {
        // End impersonation
        const adminUserEmail = getSessionStorage("impersonatorAdminUserEmail");
        removeSessionStorage("impersonatorAdminUserEmail");

        const redirectUrlForUserKey = `redirectUrl-${adminUserEmail}`;
        redirectTo = getSessionStorage(redirectUrlForUserKey);
        removeSessionStorage(redirectUrlForUserKey);
      }

      let response;

      try {
        response = yield call(AccountImpersonate, {
          ...payload,
          accessToken: authData.access_token,
        });
      } catch (error) {
        response = { ok: false };
      }

      if (response.ok) {
        yield put({ type: "configs/updatePerm", payload: {} });

        const redirectUrl = `/${redirectTo ? `?redirectTo=${redirectTo}` : ""}`;
        router.replace(redirectUrl);
      } else if (response.error) {
        yield put({
          type: "errorOnLogin",
          payload: response.error,
        });
      }
    },
  },
  reducers: {
    errorOnLogin(state, { payload }) {
      return {
        ...state,
        errorMessage: payload,
      };
    },
  },
};
export default Model;
